export default [
    {
        path: 'logradouro',
        component: () => import(
            /* webpackChunkName: 'cadastro-logradouro' */
            '@/views/cadastro/logradouro/Index'
        ),
        redirect: 'logradouro/index',
        children: [
            {
                name: 'cadastro-logradouro-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-logradouro' */
                    '@/views/cadastro/logradouro/List.vue'
                ),
            },
            {
                name: 'cadastro-logradouro-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-logradouro' */
                    '@/views/cadastro/logradouro/Form.vue'
                ),
            },
            {
                name: 'cadastro-logradouro-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-logradouro' */
                    '@/views/cadastro/logradouro/Form.vue'
                ),
            },
        ],
    },
]